import { render, staticRenderFns } from "./renewal.vue?vue&type=template&id=61b9e033"
import script from "./renewal.vue?vue&type=script&lang=js"
export * from "./renewal.vue?vue&type=script&lang=js"
import style0 from "./renewal.vue?vue&type=style&index=0&id=61b9e033&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports